export default function setSearchZipAction(searchZip) {
    return {
        type: 'SET_SEARCH_ZIP',
        payload: searchZip
    }
}